import _ from 'lodash';

import { UtmParams, dashboard } from 'types';
import { core } from '@tock/coretypes';
import { stringify } from '@tock/query-string';
import AppConstants from 'constants/AppConstants';
import protos from 'utils/protos';

const { BusinessOnboardingCreateRequest, SelfOnboardingHelpRequest } = protos;

export function createBusiness(business: core.IBusiness, utmParams?: UtmParams): ApiAction {
  return {
    TockApi: {
      postProto: `/onboarding/self/create`,
      type: AppConstants.SELF_ONBOARDING_CREATE,
      request: BusinessOnboardingCreateRequest.fromObject({
        business,
        ...utmParams,
      }),
    },
  };
}

export function getOrCreatePatronAndSendVerificationIfNeeded(email: string) {
  return checkOrGetOrCreateForPatronAndSendVerificationIfNeeded(email, true);
}

function checkOrGetOrCreateForPatronAndSendVerificationIfNeeded(
  email: string,
  createNew: boolean
): ApiAction {
  return {
    TockApi: {
      getProto:
        `/onboarding/self/check-email?` +
        stringify({
          email,
          createNew: createNew ? 'true' : 'false',
        }),
      type: AppConstants.SELF_ONBOARDING_CREATE,
    },
  };
}

export function resendActivationEmail(email: string): ApiAction {
  return {
    TockApi: {
      getProto: `/onboarding/self/activate/resend?${stringify({ email })}`,
      type: AppConstants.NULL,
      toast: 'Another activation email has been sent to your inbox',
    },
  };
}

export function getAuthenticationMethods(email: string): ApiAction {
  return {
    TockApi: {
      getListProto: `/authenticate/methods?${stringify({ email })}`,
      type: AppConstants.AUTHENTICATION_METHODS,
      onError: {
        1001: _.noop,
        5007: 'This account is locked out',
      },
    },
  };
}

export function isPatronVerified(email: string): ApiAction {
  return {
    TockApi: {
      getProto: `/verification/check?${stringify({ email })}`,
      type: AppConstants.VERIFICATION_CHECK,
    },
  };
}

export function clearSelfOnboardingData() {
  return {
    type: AppConstants.SELF_ONBOARDING_CLEAR_DATA,
  };
}

export function saveEvent(savedEvent: core.ITicketType): BaseTockAction {
  return {
    payload: {
      savedEvent,
    },
    type: AppConstants.SELF_ONBOARDING_CREATE_EVENT,
  };
}

export function saveEventTemplate(savedEventTemplate: core.IEventTemplate): BaseTockAction {
  return {
    payload: {
      savedEventTemplate,
    },
    type: AppConstants.SELF_ONBOARDING_SAVE_EVENT_TEMPLATE,
  };
}

export function saveBusinessInfo({
  phone,
  webUrl,
  phoneCountryCode,
}: {
  phone?: string;
  webUrl?: string;
  phoneCountryCode?: string;
}) {
  return {
    payload: {
      phone,
      webUrl,
      phoneCountryCode,
    },
    type: AppConstants.SELF_ONBOARDING_SAVE_BUSINESS_INFO,
  };
}

export function isDomainAvailable(domainName: string): ApiAction {
  return {
    TockApi: {
      getProto: `/business/domain?domain=${encodeURIComponent(domainName)}`,
      type: AppConstants.ONBOARDING_DOMAIN_CHECK,
    },
  };
}

export function submitSelfOnboardingHelp(request: dashboard.ISelfOnboardingHelpRequest): ApiAction {
  return {
    TockApi: {
      postProto: '/onboarding/self/help',
      type: AppConstants.SELF_ONBOARDING_HELP_SUBMIT,
      request: SelfOnboardingHelpRequest.fromObject(request),
    },
  };
}
